import { OnInit, Component } from '@angular/core';
import { VenueService } from '@core/services/venue/venue.service';
import { take, finalize } from 'rxjs/operators';
import { ListResult } from '@core/models/list-result/list-result.model';
import { VenueListItem } from '@core/models/venue/venue-list-item.model';
import { IVenueListItem } from '@core/interfaces/venue/venue-list-item.interface';
import { Marker } from '../../models/marker.model';

@Component({
  selector: 'app-venue-map',
  templateUrl: './venue-map.component.html',
  styleUrls: ['./venue-map.component.scss'],
})
export class VenueMapComponent implements OnInit {

  isLoading: boolean;
  isError: boolean;
  markers: Marker[] = [];

  constructor(
    private venueService: VenueService
  ) { }

  ngOnInit(): void {
    this.fetchVenues();
  }

  private fetchVenues() {
    this.isLoading = true;
    this.venueService.getList()
      .pipe(
        take(1),
        finalize(() => this.isLoading = false)
      )
      .subscribe({
        next: (listResult: ListResult<IVenueListItem, VenueListItem>) => {
          const markers = listResult.results.map((venue) => new Marker({
            lat: venue.address.latitude,
            lng: venue.address.longitude,
            name: venue.name,
          }));

          this.markers = markers.filter(({ lat, lng }) => (lat || lat === 0) && (lng || lng === 0));
        },
        error: () => this.isError = true,
      });
  }

}

